import {QbElement} from "@qb-assets-js/qb-elements/qb-element"


class QbGettextEdit extends QbElement {
    static nodeName = 'qb-gettext-edit'
    static shadow = {mode: 'open', sheets: ["qb-elements"]};
    // static template = "<textarea></textarea>";
    static template = "<slot></slot><nav></nav>";

    #languageSelect
    #translateSelect
    #range

    constructor() {
        super();
        this.addEventListener("contextmenu", this, {capture: true});
        this.addEventListener("click", this);
        // this.addEventListener("beforeinput", this);
        this.addEventListener("paste", this);
        this.addEventListener("drop", this);
        this.addEventListener("keyup", this, {passive: true});
        this.addEventListener("keydown", this);
        const beforeend = this.contentRoot.lastElementChild;
        const languages = document.languages.map(([value, data]) => OPTION({value}, data.flag, "\u2003", data.name));

        this.#languageSelect = SELECT({
            beforeend,
            name: "language"
        }, ...languages);
        this.#languageSelect.addEventListener("change", this);

        const translations = document.languages.map(([value, data]) => OPTION({value}, data.flag, "\u2003", data.name));
        translations.shift();
        this.#translateSelect = SELECT({
            beforeend,
            name: "translate"
        }, OPTION({value: ""}, "文A Translate to ..."), ...translations);
        this.#translateSelect.addEventListener("change", evt=>this.#translate(evt));
        BUTTON({beforeend, name: "cancel"}).addEventListener("click", e=>this.cancel);
    }

    get cancel() {
        this.parentElement.removeClass("changed");
        this.remove();
    }

    get save() {
        if(this.#content === this.tex) return this.remove();
        this.dispatch("qb-patch", {
            action: "gettext",
            attribute: this.parentElement.itemprop,
            value: this.content
        });
    }


    saveOK(data) {
        this.remove();
    }

    #translate(evt) {
        const iso = evt.currentTarget.value;
        console.log(document.languages.values[iso]);
        evt.currentTarget.selectedIndex = 0;
    }

    get content() {
        return this.textContent.replace(/^#+(?=\s|$)/gm, match => '\\' + match);
    }

    #content;
    set content(value) {
        this.innerHTML = ""; // Clear existing content
        const parts = value.split(/(?=(?:\s|^)@\w{2}(?=\s))/gm); // Split while keeping marker
        for(let part of parts) {
            if(!part.trim()) continue;
            if(!part.startsWith("@")) part = "@xx " + part;
            const textNode = document.createTextNode(part);
            textNode.lang = part.slice(1, 3);
            this.appendChild(textNode);
        }
        this.appendChild(document.createElement("br"));
        this.#content = this.textContent;
    }

    get #changed() {
        const changed = this.#content !== this.textContent;
        this.parentElement.setClass(changed, "changed");
        this.setClass(changed, "changed");
        return changed;
    }

    set language(value) {
        this.#languageSelect.value = value;
        [...this.#translateSelect.children].forEach(n=>n.disabled = false);
        const node = this.#translateSelect.querySelector(`[value="${value}"]`);
        if(node) node.disabled = true;
    }

    handleEvent(evt) {
        evt.stopImmediatePropagation();
        switch(evt.type) {
            case "keydown":
                if(evt.key === "Enter") this.#handleEnter(evt);
                else if(evt.key === "Tab") return;

                return;
            case "change":
                this.#currentLanguage = evt.currentTarget.value;
                break;
            case "keyup":
                this.#handleKeyup(evt);
            case "click":
                this.#currentLanguage;
                break;
            case "paste":
                return this.#pasteOrDrop(evt, evt.clipboardData);
            case "drop":
                return this.#pasteOrDrop(evt, evt.dataTransfer);
        }
    }

    #replaceContainer(node, text, lang) {
        const textNode = document.createTextNode(text);
        textNode.lang = lang || node.lang;
        node.replaceWith(textNode);
        return textNode;
    }

    #handleKeyup(evt) {
        this.#changed;
        const selection = window.getSelection();
        if(!selection || selection.rangeCount === 0) return null;
        let {startContainer, startOffset} = selection.getRangeAt(0);
        if(startContainer.nodeType !== Node.TEXT_NODE) return;
        let data = startContainer.data;
        if(startContainer.lang !== data.slice(1,3)) {
            const previousContainer = startContainer.previousSibling;
            if(!previousContainer) {
                startContainer.lang = "xx";
                return;
            }
            else {
                startContainer.remove();
                startOffset += previousContainer.data.length;
                const textNode = this.#replaceContainer(previousContainer, previousContainer.data + data);
                selection.setPosition(textNode, startOffset);
            }
            return;
        }
        if(startOffset < 4) return;
        const m = data.slice(startOffset - 4).match(/@(\w{2})/);
        if(!m) return;
        if(startOffset > 4 && !/\s/.test(data[startOffset - 5])) return;
        const newNode = startContainer.splitText(startOffset - 4);
        newNode.lang = newNode.data.slice(1, 3);
    }

    #handleEnter(evt) {
        evt.preventDefault();
        const selection = window.getSelection();
        if(!selection || selection.rangeCount === 0) return null;
        let {startContainer, startOffset, endOffset} = selection.getRangeAt(0);
        if(startContainer.nodeType !== Node.TEXT_NODE) return;
        if(startOffset) {
            const before = startContainer.data.slice(0, startOffset),
                after = startContainer.data.slice(endOffset);
            const textNode = this.#replaceContainer(startContainer, before + "\n" + after);
            selection.setPosition(textNode, endOffset + 1);
        }
        else if(startContainer.previousSibling) {
            startContainer = startContainer.previousSibling;
            const textNode = this.#replaceContainer(startContainer, startContainer.data + "\n");
            selection.setPosition(textNode, textNode.data.length);
        }
    }

    #pasteOrDrop(evt, data) {
        evt.preventDefault();
        const text = data.getData('text/plain');
        document.execCommand('insertText', false, text);
        this.querySelectorAll("*").forEach(n => n.replaceWith("\n" + n.textContent + "\n"));
    }

    get #currentLanguage() {
        const selection = window.getSelection();
        if(!selection || selection.rangeCount === 0) return null;
        this.#range = selection.getRangeAt(0);
        const startContainer = this.#range.startContainer;
        if(startContainer.nodeType !== Node.TEXT_NODE) return;
        return this.language = startContainer.lang;
    }

    set #currentLanguage(value) {

        // TODO DAS GEHT NICHT
        const selection = window.getSelection();
        if(!selection || selection.rangeCount === 0) return null;
        const {startContainer, startOffset} = this.#range = selection.getRangeAt(0);
        if(startContainer.nodeType !== Node.TEXT_NODE) return;
        this.language = value;
        if(startContainer.lang === value) return;
        const textNode = this.#replaceContainer(startContainer, `@${value} ` + startContainer.data.replace(/^@\w{2}\s*/, ""));
        selection.setPosition(textNode, startOffset);
    }
}

QbGettextEdit.register;